import { Card as MuiCard, type CardProps as MuiCardProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiCardProps, 'variant' | 'elevation' | 'square' | 'raised'>>;

export function Card(props: Props) {
  return <MuiCard {...props} variant="outlined" />;
}

export type { Props as CardProps };
